/**
 * Marketing Box Tabs. Funktioniert sowohl fuer serverseitige EventBoxen als
 * auch fuer nachtraeglich per ProductRecommender geladenes Dynamics-Markup.
 */
(function () {
  const TAB_ACTIVE_CLASSES = ['text-white', 'border-white/30', 'bg-white/10', 'shadow-lg', 'shadow-black/10', 'backdrop-blur-lg'];
  const TAB_INACTIVE_CLASSES = ['text-white/80', 'hover:text-white', 'hover:border-white/10', 'hover:bg-white/10', 'hover:shadow-sm', 'hover:shadow-black/5'];
  const LABEL_ACTIVE_CLASS = 'text-white';
  const LABEL_INACTIVE_CLASS = 'text-white/50';

  function activateTab(tabs, panels, index) {
    tabs.forEach(function (tab, i) {
      const active = i === index;
      const label = tab.querySelector('span:first-child');

      TAB_ACTIVE_CLASSES.forEach(function (cls) { tab.classList.toggle(cls, active); });
      TAB_INACTIVE_CLASSES.forEach(function (cls) { tab.classList.toggle(cls, !active); });
      tab.classList.toggle('border-transparent', !active);

      if (active) tab.setAttribute('aria-current', 'page');
      else tab.removeAttribute('aria-current');

      if (label) {
        label.classList.toggle(LABEL_ACTIVE_CLASS, active);
        label.classList.toggle(LABEL_INACTIVE_CLASS, !active);
      }
    });

    panels.forEach(function (panel, i) {
      panel.classList.toggle('hidden', i !== index);
    });
  }

  function initContainer(container) {
    const panels = Array.from(container.querySelectorAll('[data-event-panel]'));
    const tabs = Array.from(container.querySelectorAll('ul a'));
    if (!panels.length || !tabs.length) return;

    let initialIndex = tabs.findIndex(function (tab) { return tab.getAttribute('aria-current') === 'page'; });
    if (initialIndex < 0) initialIndex = 0;

    activateTab(tabs, panels, initialIndex);

    tabs.forEach(function (tab, index) {
      if (tab.getAttribute('data-event-tab-initialized') === 'true') return;
      tab.setAttribute('data-event-tab-initialized', 'true');
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        activateTab(tabs, panels, index);
      });
    });
  }

  function init(root) {
    if (root && root.matches && root.matches('[data-event-tabs-container]')) initContainer(root);
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-event-tabs-container]').forEach(initContainer);
  }

  window.IwwMarketingBoxTabs = {init: init};

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
